export interface TabStripMetrics {
    scrollLeft: number;
    clientWidth: number;
    scrollWidth: number;
}

export interface HiddenTabEdges {
    start: boolean;
    end: boolean;
}

// Fractional widths and borders leave a few pixels of "overflow" that hide no tab; no fade for those.
const OVERFLOW_TOLERANCE_PX = 4;

export function hiddenTabEdges({
    scrollLeft,
    clientWidth,
    scrollWidth
}: TabStripMetrics): HiddenTabEdges {
    return {
        start: scrollLeft > OVERFLOW_TOLERANCE_PX,
        end: scrollLeft + clientWidth < scrollWidth - OVERFLOW_TOLERANCE_PX
    };
}

export interface TabPlacement {
    scrollLeft: number;
    clientWidth: number;
    /** Tab offset from the start of the scrolled content. */
    tabLeft: number;
    tabWidth: number;
}

function revealTarget(
    { scrollLeft, clientWidth, tabLeft, tabWidth }: TabPlacement,
    fadePx: number
): number {
    const tabRight = tabLeft + tabWidth;
    if (tabLeft < scrollLeft + fadePx) return Math.max(0, tabLeft - fadePx);
    if (tabRight > scrollLeft + clientWidth - fadePx) return tabRight + fadePx - clientWidth;
    return scrollLeft;
}

// Scroll position that brings the tab clear of the edge fades, or null when no scroll is needed.
export function scrollLeftToReveal(placement: TabPlacement, fadePx: number): number | null {
    const target = revealTarget(placement, fadePx);
    return target === placement.scrollLeft ? null : target;
}
